const faults = {
  CART_EXPIRED: 1019,
  OFFERING_NOT_FOUND: 1149,
  INVALID_SYSTEM_ID: 104,
  SESSION_EXPIRED: 109,
  INVALID_PARAMETER: 27,
  USER_HAS_NO_ADDRESS_FAULT: 1120,
  UNKNOWN: '0',
};

export default faults;
